import React, {useEffect, useRef, useState} from "react";
import Samples from "../parts/Samples";
import Problem from "../parts/Problem";
import About from "../parts/About";
import Testimonial from "../parts/Testimonial";
import Discounts from "../parts/Discounts";
import Faq from "../parts/Faq";
import Calc from "../parts/Calc";
import Modal from "./Modal";

export default function Services() {
    document.getElementById("map").style.display = "none"

    const handleScroll = () => {
        const position = window.pageYOffset;
        if (document.querySelector("#endServices") || document.querySelector("#endAbout") || document.querySelector("#endFaq") || document.querySelector("#endDiscounts")) {
            //console.log('pos', position)
            const rect1Y = document.querySelector("#endServices").getBoundingClientRect().top
            const rect2Y = document.querySelector("#endAbout").getBoundingClientRect().top
            const rect3Y = document.querySelector("#endFaq").getBoundingClientRect().top
            const rect4Y = document.querySelector("#endDiscounts").getBoundingClientRect().top
            // console.log('rect1', rect1Y)
            // console.log('rect2', rect2Y)
            // console.log('rect3', rect3Y)
            // console.log('rect4', rect4Y)
            if (position>0 && position < rect1Y && rect1Y > 10) {
                document.getElementById('services').classList.add('dropdown-toggle')
                document.getElementById('about').classList.remove('dropdown-toggle')
                document.getElementById('testimonial').classList.remove('dropdown-toggle')
                document.getElementById('discount').classList.remove('dropdown-toggle')
                document.getElementById('faq').classList.remove('dropdown-toggle')
                document.getElementById('blog').classList.remove('dropdown-toggle')
                document.getElementById('contacts').classList.remove('dropdown-toggle')
                document.getElementById('services').style.color = "#FFAB2D"
                document.getElementById('about').style.color = "#FFFFFF"
                document.getElementById('testimonial').style.color = "#FFFFFF"
                document.getElementById('discount').style.color = "#FFFFFF"
                document.getElementById('faq').style.color = "#FFFFFF"
                document.getElementById('blog').style.color = "#FFFFFF"
                document.getElementById('contacts').style.color = "#FFFFFF"
            }
            else if (position > rect1Y && rect2Y > 10) {
                document.getElementById('services').classList.remove('dropdown-toggle')
                document.getElementById('about').classList.add('dropdown-toggle')
                document.getElementById('testimonial').classList.remove('dropdown-toggle')
                document.getElementById('discount').classList.remove('dropdown-toggle')
                document.getElementById('faq').classList.remove('dropdown-toggle')
                document.getElementById('blog').classList.remove('dropdown-toggle')
                document.getElementById('contacts').classList.remove('dropdown-toggle')
                document.getElementById('services').style.color = "#FFFFFF"
                document.getElementById('about').style.color = "#FFAB2D"
                document.getElementById('testimonial').style.color = "#FFFFFF"
                document.getElementById('discount').style.color = "#FFFFFF"
                document.getElementById('faq').style.color = "#FFFFFF"
                document.getElementById('blog').style.color = "#FFFFFF"
                document.getElementById('contacts').style.color = "#FFFFFF"
            }
            else if (position > rect2Y && rect3Y > 10) {
                document.getElementById('services').classList.remove('dropdown-toggle')
                document.getElementById('about').classList.remove('dropdown-toggle')
                document.getElementById('testimonial').classList.remove('dropdown-toggle')
                document.getElementById('discount').classList.remove('dropdown-toggle')
                document.getElementById('faq').classList.add('dropdown-toggle')
                document.getElementById('blog').classList.remove('dropdown-toggle')
                document.getElementById('contacts').classList.remove('dropdown-toggle')
                document.getElementById('services').style.color = "#FFFFFF"
                document.getElementById('about').style.color = "#FFFFFF"
                document.getElementById('testimonial').style.color = "#FFFFFF"
                document.getElementById('discount').style.color = "#FFFFFF"
                document.getElementById('faq').style.color = "#FFAB2D"
                document.getElementById('blog').style.color = "#FFFFFF"
                document.getElementById('contacts').style.color = "#FFFFFF"
            }
            else if (position > rect3Y && rect4Y > 50) {
                document.getElementById('services').classList.remove('dropdown-toggle')
                document.getElementById('about').classList.remove('dropdown-toggle')
                document.getElementById('testimonial').classList.remove('dropdown-toggle')
                document.getElementById('discount').classList.add('dropdown-toggle')
                document.getElementById('faq').classList.remove('dropdown-toggle')
                document.getElementById('blog').classList.remove('dropdown-toggle')
                document.getElementById('contacts').classList.remove('dropdown-toggle')
                document.getElementById('services').style.color = "#FFFFFF"
                document.getElementById('about').style.color = "#FFFFFF"
                document.getElementById('testimonial').style.color = "#FFFFFF"
                document.getElementById('discount').style.color = "#FFAB2D"
                document.getElementById('faq').style.color = "#FFFFFF"
                document.getElementById('blog').style.color = "#FFFFFF"
                document.getElementById('contacts').style.color = "#FFFFFF"
            }
            else if (rect4Y < 50) {
                document.getElementById('services').classList.remove('dropdown-toggle')
                document.getElementById('about').classList.remove('dropdown-toggle')
                document.getElementById('testimonial').classList.add('dropdown-toggle')
                document.getElementById('discount').classList.remove('dropdown-toggle')
                document.getElementById('faq').classList.remove('dropdown-toggle')
                document.getElementById('blog').classList.remove('dropdown-toggle')
                document.getElementById('contacts').classList.remove('dropdown-toggle')
                document.getElementById('services').style.color = "#FFFFFF"
                document.getElementById('about').style.color = "#FFFFFF"
                document.getElementById('testimonial').style.color = "#FFAB2D"
                document.getElementById('discount').style.color = "#FFFFFF"
                document.getElementById('faq').style.color = "#FFFFFF"
                document.getElementById('blog').style.color = "#FFFFFF"
                document.getElementById('contacts').style.color = "#FFFFFF"
            }
        }
        else return
    }
   

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true })
            setTimeout(() => {
                document.getElementById("modal").style.display = "block"
            }, 10000);
            
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);
    //#region  стили
    const stylebank = {
        color: "white",
    }
   
    const stylebutton = {
        backgroundColor: "#FFAB2D",
        color: "white",
        fontSize: "18px",
        fontWeight: "bold",
        borderRadius: "5px",
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingLeft: "40px",
        paddingRight: "40px",
        border: 0
    }
    
    const styleworktitle = {
        width: "fit-content",
        paddingRight: "20px",
        paddingLeft: "20px",
        height: "70px",
        marginLeft: "30px"
    }
    const styleworkheight = {
        height: "70px"
    }
    
    const styleworkline = {
        height: "2px",
        width: "62%",
        padding: "0",
        marginTop: "35px",
        marginLeft: "30px"
    }
    
    const styleprice = {
        fontSize: '18px',
        color: '#a8a8a8',
        textDecoration: 'line-through',
        fontWeight: "bold",
    }
    const stylediscount = {
        fontSize: '24px',
        color: '#484848',
        fontWeight: "bold",
    }
    const Card1 = () => {
        document.getElementById("card1").style.display = "block"
        document.getElementById("card1_").style.display="none"
    }
    const Card1_ = () => {
        document.getElementById("card1").style.display = "none"
        document.getElementById("card1_").style.display="block"
    }
    const Card2 = () => {
        document.getElementById("card2").style.display = "block"
        document.getElementById("card2_").style.display="none"
    }
    const Card2_ = () => {
        document.getElementById("card2").style.display = "none"
        document.getElementById("card2_").style.display="block"
    }
     const Card3 = () => {
        document.getElementById("card3").style.display = "block"
        document.getElementById("card3_").style.display="none"
    }
    const Card3_ = () => {
        document.getElementById("card3").style.display = "none"
        document.getElementById("card3_").style.display="block"
    }
     const Card4 = () => {
        document.getElementById("card4").style.display = "block"
        document.getElementById("card4_").style.display="none"
    }
    const Card4_ = () => {
        document.getElementById("card4").style.display = "none"
        document.getElementById("card4_").style.display="block"
    }
     const Card5 = () => {
        document.getElementById("card5").style.display = "block"
        document.getElementById("card5_").style.display="none"
    }
    const Card5_ = () => {
        document.getElementById("card5").style.display = "none"
        document.getElementById("card5_").style.display="block"
    }
    const Card6 = () => {
        document.getElementById("card6").style.display = "block"
        document.getElementById("card6_").style.display="none"
    }
    const Card6_ = () => {
        document.getElementById("card6").style.display = "none"
        document.getElementById("card6_").style.display="block"
    }
    //#endregion стили
    const call = () => {
        document.getElementById("modal").style.top = "20%"
        document.getElementById("modal").style.left = "20%"
        document.getElementById("modal").style.display = "block"
       
}
    
    return (
        <>
            <Modal/>
        <div className="main" >
        <div id="maintext">
            <div className="maintext1">Законно спишем долги,</div>
            <div className="maintext1">кредиты, займы</div>
            <ul id="maintext2">
                <li className="maintext2"><span>•</span>	Списано с клиентов более <b>1,5 млрд. рублей</b></li>
                <li className="maintext2"><span>•</span>	Вся процедура <b>за 6 месяцев</b></li>
                <li className="maintext2"><span>•</span>	Работаем по договору</li>
                <li className="maintext2"><span>•</span>	Опыт работы 11 лет</li>
                <li className="maintext2"><span>•</span>	Помощь 24\7</li>
                    </ul>
                <div id="call" onClick={call}>Заказать звонок</div>
        </div>
        <div id='main'>
            <img id="mainmen" src="../images/men.png" />
        </div>
        <div id='linetop'></div>
        <div id='bankruptcy' className="container-fluid">
            <div className="row">
            <div id='bankruptcytitle'>Банкротство</div>
                <div className="column-2 " id="line" style={styleworkline}></div>
                </div>
            <div className='row'>
                <div className="col-sm" >
                    <div className="bankblock" id="card1_" onMouseOver={Card1} onMouseOut={Card1_}>Банкротство физических лиц
                    <a href="/card1#card" className="details">Подробнее <span className="arrow">&#8594;</span></a></div>

                    <div className="bankblock" id="card1"><img id='bank1' src="../images/card1.png" />
                    <img id="hand" src="../images/hand.png"/>
                    <div id="detailsbank1">Банкротство физических лиц</div>
                    <a href="/card1#card" id="detailsbank1_" style={stylebank}>Подробнее &#8594;</a></div>
                </div>
                <div className="col-sm">
                    <div className="bankblock" id="card2_" onMouseOver={Card2} onMouseOut={Card2_}>Банкротство индивидуальных предпринимателей
                    <a href="/card1#card" className="details">Подробнее <span className="arrow">&#8594;</span></a></div>

                     <div className="bankblock" id="card2" ><img id='bank1' src="../images/card2.png" />
                    <img id="hand" src="../images/hand.png"/>
                    <div id="detailsbank2">Банкротство индивидуальных предпринимателей</div>
                    <a href="/card1#card" id="detailsbank2_" style={stylebank}>Подробнее &#8594;</a></div>
                </div>
                <div className="col-sm">
                   <div className="bankblock" id="card3_" onMouseOver={Card3} onMouseOut={Card3_}>Внесудебное банкротство
                    <a href="/card1#card" className="details">Подробнее <span className="arrow">&#8594;</span></a></div>

                    <div className="bankblock" id="card3" ><img id='bank1' src="../images/card3.png" />
                    <img id="hand" src="../images/hand.png"/>
                    <div id="detailsbank3">Внесудебное банкротство</div>
                    <a href="/card1#card" id="detailsbank3_" style={stylebank}>Подробнее &#8594;</a></div>
                </div>
                <div className="col-sm ">
                    <div className="bankblock"  id="card4_" onMouseOver={Card4} onMouseOut={Card4_}>Банкротство с имуществом и\или ипотекой
                    <a href="/card1#card" className="details">Подробнее <span className="arrow">&#8594;</span></a></div>
               
                    <div className="bankblock" id="card4" ><img id='bank1' src="../images/card4.png" />
                    <img id="hand" src="../images/hand.png"/>
                    <div id="detailsbank4">Банкротство с имуществом и\или ипотекой</div>
                    <a href="/card1#card" id="detailsbank4_" style={stylebank}>Подробнее &#8594;</a></div>
                </div>
                <div className="col-sm">
                    <div className="bankblock"  id="card5_" onMouseOver={Card5} onMouseOut={Card5_}>Банкротство пенсионеров
                    <a href="/card1#card" className="details">Подробнее <span className="arrow">&#8594;</span></a></div>
                
                    <div className="bankblock" id="card5" ><img id='bank1' src="../images/card5.png" />
                    <img id="hand" src="../images/hand.png"/>
                    <div id="detailsbank5">Банкротство пенсионеров</div>
                    <a href="/card1#card" id="detailsbank5_" style={stylebank}>Подробнее &#8594;</a></div>
                </div>
                <div className="col-sm">
                    <div className="bankblock" id="card6_" onMouseOver={Card6} onMouseOut={Card6_}>Банкротство поручителей
                    <a href="/card1#card" className="details">Подробнее <span className="arrow">&#8594;</span></a></div>

                    <div className="bankblock" id="card6" ><img id='bank1' src="../images/card6.png" />
                    <img id="hand" src="../images/hand.png"/>
                    <div id="detailsbank6">Банкротство поручителей</div>
                    <a href="/card1#card" id="detailsbank6_" style={stylebank}>Подробнее &#8594;</a></div>
                </div>
            </div>
        </div>
        <div id='linebottom' id='bank2_'></div>
        <div className='fonlogo'><img id='bank2' src='../images/bank2.png' />
            Учитывая ключевые сценарии поведения, высокотехнологичная концепция общественного уклада однозначно фиксирует необходимость новых принципов формирования материально-технической и кадровой базы! Лишь некоторые особенности внутренней политики освещают чрезвычайно интересные особенности картины в целом, однако конкретные выводы, разумеется, подвергнуты целой серии независимых исследований. Непосредственные участники технического прогресса призывают нас к новым свершениям, которые, в свою очередь, должны быть описаны максимально подробно.Непосредственные участники технического прогресса призывают нас к новым свершениям, которые, в свою очередь, должны быть описаны максимально подробно.Лишь некоторые особенности внутренней политики освещают чрезвычайно интересные особенности картины в целом, однако конкретные выводы, разумеется, подвергнуты целой серии независимых исследований.
Предварительные выводы неутешительны: выбранный нами инновационный путь выявляет срочную потребность существующих финансовых и административных условий. Но явные признаки победы институционализации, которые представляют собой яркий пример континентально-европейского типа политической культуры, будут объявлены нарушающими общечеловеческие нормы этики и морали! Ясность нашей позиции очевидна: граница обучения кадров способствует повышению качества форм воздействия. Равным образом, убеждённость некоторых оппонентов позволяет выполнить важные задания по разработке направлений прогрессивного развития. С учётом сложившейся международной обстановки, начало повседневной работы по формированию позиции позволяет оценить значение глубокомысленных рассуждений.</div>
       <Problem/>
        
        <div id='linetop2'></div>

        <div id="solutionfon">
            <span id="solution">Готовые решения по банкротству с перечнем<br/>
                работ и расчётом стоимости</span>
            
            <div id="solutionin">
                <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4" id="sol1">Внесудебное банкротство с сопровождением юристов «под ключ»</div>
                    <div className="col-sm-5" id="sol2"><ul>
                    <li><span>•</span>	Подача документов в МФЦ</li>
                    <li><span>•</span>	Сбор документов</li>
                    <li><span>•</span>	Составление списка кредиторов</li>
                    <li><span>•</span>	Составление заявления на банкротство</li>
                    <li><span>•</span>	Анализ сделок должника за последние 3 года</li>
                    <li><span>•</span>	Консультирование в течение всего срока банкротства (6 месяцев)</li>
                    </ul>
                    <a href="#" id="details2">Подробнее</a>
                    </div>
                    <div className="col-sm-3 align-self-center" id="sol3">
                        <p style={styleprice}>25 000 ₽</p>
                        <p style={stylediscount}>23 000 ₽</p>
                        <button style={stylebutton}>Списать долг</button>
                    </div>
                </div>
            </div>
            </div>

            <div id="solutionin">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4" id="sol1">Подготовка к процедуре внесудебного банкротства</div>
                    <div className="col-sm-5" id="sol2"><ul>
                    <li><span>•</span>	Сбор документов</li>
                    <li><span>•</span>	Составление списка кредиторов</li>
                    <li><span>•</span>	Составление заявления на банкротство</li>
                    </ul>
                    <a href="#" id="details2">Подробнее</a>
                    </div>
                    <div className="col-sm-3 align-self-center" id="sol3">
                        <p style={stylediscount}>15 000 ₽</p>
                        <button style={stylebutton}>Списать долг</button>
                    </div>
                </div>
             </div>
            </div> 

            <div id="solutionin">
                <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4" id="sol1">Внесудебное банкротство с сопровождением юристов «под ключ»</div>
                    <div className="col-sm-5" id="sol2"><ul>
                    <li><span>•</span>	Подача документов в МФЦ</li>
                    <li><span>•</span>	Сбор документов</li>
                    <li><span>•</span>	Составление списка кредиторов</li>
                    <li><span>•</span>	Составление заявления на банкротство</li>
                    <li><span>•</span>	Анализ сделок должника за последние 3 года</li>
                    <li><span>•</span>	Консультирование в течение всего срока банкротства (6 месяцев)</li>
                    </ul>
                    <a href="#" id="details2">Подробнее</a>
                    </div>
                    <div className="col-sm-3 align-self-center" id="sol3">
                        <p style={styleprice}>25 000 ₽</p>
                        <p style={stylediscount}>23 000 ₽</p>
                        <button style={stylebutton}>Списать долг</button>
                    </div>
                    </div>
                </div>
            </div>

            <div id="solutionin">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-4" id="sol1">Подготовка к процедуре внесудебного банкротства</div>
                    <div className="col-sm-5" id="sol2"><ul>
                    <li><span>•</span>	Сбор документов</li>
                    <li><span>•</span>	Составление списка кредиторов</li>
                    <li><span>•</span>	Составление заявления на банкротство</li>
                    </ul>
                    <a href="#" id="details2">Подробнее</a>
                    </div>
                    <div className="col-sm-3 align-self-center" id="sol3">
                        <p style={stylediscount}>15 000 ₽</p>
                        <button style={stylebutton}>Списать долг</button>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div id='linebottom2'></div>

        <Problem/>

        <div className='fonlogo fonlogo2'><img id='bank2' src='../images/bank2.png' />
            Учитывая ключевые сценарии поведения, высокотехнологичная концепция общественного уклада однозначно фиксирует необходимость новых принципов формирования материально-технической и кадровой базы! Лишь некоторые особенности внутренней политики освещают чрезвычайно интересные особенности картины в целом, однако конкретные выводы, разумеется, подвергнуты целой серии независимых исследований. Непосредственные участники технического прогресса призывают нас к новым свершениям, которые, <a href="#bank2_">в свою очередь,...</a></div>

        <div id='linetop3'></div>
        <div id='bankruptcy'>
            <div className="container-fluid">
                <div className="row" style={styleworkheight}>
                    <div className="column-2" id='bankruptcytitle' style={styleworktitle}>Как мы работаем</div>
                    <div className="column-2" id="line" style={styleworkline}></div>
                </div>
            </div>
            <div className="container-fluid">
                <div className='row'>
                    <div className="col-sm-4 text-center">
                        <div className="short"><img src="../images/short1.png" />
                            <div className="worktitle">Бесплатная консультация</div>
                            <div className="worktext">Вы оставляете заявку на нашем сайте, после этого вам перезвонит наш юрист и проконсультирует</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <div className="short"><img src="../images/short2.png" />
                            <div className="worktitle">Составляем договор</div>
                            <div className="worktext">Для начала сотрудничества мы составим подробный план действий по вашей ситуации</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center" >
                        <div className="short"><img src="../images/short3.png" />
                            <div className="worktitle">Готовим документы</div>
                            <div className="worktext">Сбор документов, необходимых для успешной процедуры списания кредитов и долгов</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <div className="short"><img src="../images/short4.png" />
                            <div className="worktitle">Подаём заявление</div>
                            <div className="worktext">При наличии полного пакета документов, мы финансируем расходы и подаём заявление на банкротство</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <div className="short"><img src="../images/short5.png" />
                            <div className="worktitle">Банкротимся</div>
                            <div className="worktext">Предоставим кандидатуру финансового управляющего, получим судебный акт о введении процедуры банкротства.</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <div className="short"><img src="../images/short6.png" />
                            <div className="worktitle">Списываем долги</div>
                            <div className="worktext">Мы сопровождаем процедуру банкротства от ее начала, до судебного акта о завершении банкротства и списании долгов.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id='linebottom'></div>

        <Calc/>

        <Samples/>
        <div id="endServices" /> 
        
        <About />
        <div id="endAbout"/>
        
        <Faq/>
        <div id="endFaq"/>
        
        <div id="afterbankruptcy">
            <img src="../images/sign.png"/>
            <div id="afterbankruptcytitle" className="text-center">Последствия банкротства</div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm">
                        <div id="minus" className="text-center">Минусы</div>
                        <div id="minustext">
                            <ul>
                                <li>Продажа имущества должника</li>
                                <li>Запрет на 3 года участвовать в управлении организацией</li>
                                <li>При получении займов и кредитов обязаны сообщить, что вы признаны банкротом</li>
                                <li>Финансовый контроль на период проведения процедуры банкротства</li>
                                <li>Ограничения на совершение сделок на время банкротства</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div id="plus" className="text-center">Плюсы</div>
                        <div id="plustext">
                            <ul>
                                <li>Иммунитет от взыскания на единственное жилье и долю супруга</li>
                                <li>Вы сможете зарегистрироваться в качестве индивидуального предпринимателя</li>
                                <li>Списание всех займов, кредитов, в том числе долгов по налогам</li>
                                <li>Отзыв всех исполнительных листов, прекращаются взыскания, коллекторы и банки не имеют права звонить и приходить</li>
                                <li>Снятие ограничений на выезд за границу</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="certificates">
            <img id="arrowleft" src="../images/arrowleft.png"/>
            <img id="arrowright" src="../images/arrowright.png"/>
            <div id="certtitle" className="text-center">Сертификаты</div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-3"><img className="certpic" src="../images/svid.png"/></div>
                    <div className="col-sm-3"><img className="certpic" src="../images/svid.png"/></div>
                    <div className="col-sm-3"><img className="certpic" src="../images/svid.png"/></div>
                    <div className="col-sm-3"><img className="certpic" src="../images/svid.png"/></div>
                </div>
            </div>
        </div>

        <Discounts/>
        <div id="endDiscounts"/>
        
        <Testimonial/>

        
    </div>
 </>
            )
}